
    import '/home/ec2-user/Youlify-Design/components/list/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["list-demo-simple","list-demo-basic","list-demo-loadmore","list-demo-vertical","list-demo-pagination","list-demo-grid","list-demo-grid-test","list-demo-responsive","list-demo-infinite-load","list-demo-virtual-list","list-demo-component-token","list-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/list/index.en-US.md?type=demo')
};